import { render, staticRenderFns } from "./portalWrapper.vue?vue&type=template&id=77165f09"
import script from "./portalWrapper.vue?vue&type=script&lang=js"
export * from "./portalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports